import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from './components/Layout/Layout';

// Páginas
import Inicio       from './pages/Inicio/Inicio';
import QuienesSomos from './pages/QuienesSomos/QuienesSomos';
import Historia     from './pages/Historia/Historia';
import Staff        from './pages/Staff/Staff';
import Proposito    from './pages/Proposito/Proposito';
import Servicios    from './pages/Servicios/Servicios';
import ProgramaMG   from './pages/ProgramaMG/ProgramaMG';
import Noticias     from './pages/Noticias/Noticias';
import Contacto     from './pages/Contacto/Contacto';
import NotFound     from './pages/NotFound/NotFound';

// Estilos globales
import './styles/global.css';

function App() {
  return (
    <Router>
      <Layout>
        <Routes>
          <Route path="/"                        element={<Inicio />} />
          <Route path="/quienes-somos"           element={<QuienesSomos />} />
          <Route path="/quienes-somos/historia"  element={<Historia />} />
          <Route path="/quienes-somos/staff"     element={<Staff />} />
          <Route path="/quienes-somos/proposito" element={<Proposito />} />
          <Route path="/servicios"               element={<Servicios />} />
          <Route path="/programa-mg"             element={<ProgramaMG />} />
          <Route path="/noticias"                element={<Noticias />} />
          <Route path="/contacto"                element={<Contacto />} />
          <Route path="*"                        element={<NotFound />} />
        </Routes>
      </Layout>
    </Router>
  );
}

export default App;
